import { combineReducers, configureStore } from "@reduxjs/toolkit";
import hardSet from "redux-persist/es/stateReconciler/hardSet";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import {
  loaderDataReducer,
  userDataReducer,
  chatDataReducer,
  feedDataReducer,
  paymentDataReducer,
  notificationDataReducer,
  influencersOnlineDataReducer,
  nameConfigurableReducer,
  filterListDataReducer,
  localFiltersReducer,
  userSubscriptionsReducer,
  searchedInfluencersReducer,
  videoPlayerReducer,
} from "./reducers";
import { storiesDataReducer } from "./reducers/storiesData";

export const rootReducer = combineReducers({
  userData: userDataReducer,
  paymentData: paymentDataReducer,
  notificationData: notificationDataReducer,
  nameConfigurable: nameConfigurableReducer,
  loaderData: loaderDataReducer,
  feedData: feedDataReducer,
  influencersOnlineData: influencersOnlineDataReducer,
  chatData: chatDataReducer,
  searchInfluencer: searchedInfluencersReducer,
  filterListData: filterListDataReducer,
  localFilters: localFiltersReducer,
  userSubscriptions: userSubscriptionsReducer,
  videoPlayer: videoPlayerReducer,
  storiesData: storiesDataReducer,
});

const persistConfig = {
  key: "root",
  storage,
  keyPrefix: "",
  stateReconciler: hardSet,
  blacklist: ["loaderData"],
};

const pReducer = persistReducer(persistConfig, rootReducer);

const devTools = process.env.REACT_APP_BACKEND_ENV === "prod" ? false : true;

export const store = configureStore({
  reducer: pReducer,
  devTools,
  middleware: (getDefaultMiddleware) =>
    devTools
      ? getDefaultMiddleware({ serializableCheck: false })
      : getDefaultMiddleware({ serializableCheck: false }),
});

export const persistor = persistStore(store);
